/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import AqaAccountResponse from '../model/AqaAccountResponse';
import AqaFolder from '../model/AqaFolder';
import AqaOtpResponse from '../model/AqaOtpResponse';
import AqaPaymentMethod from '../model/AqaPaymentMethod';
import AqaPersonalisationSettings from '../model/AqaPersonalisationSettings';
import AqaQualityDefinition from '../model/AqaQualityDefinition';
import AqaQualityDefinitionResponse from '../model/AqaQualityDefinitionResponse';
import AqaQualityDefinitionUpdateResponse from '../model/AqaQualityDefinitionUpdateResponse';
import AqaResponse from '../model/AqaResponse';
import AqaScore from '../model/AqaScore';
import AqaSnapshot from '../model/AqaSnapshot';
import AqaSnapshotResponse from '../model/AqaSnapshotResponse';
import AqaSource from '../model/AqaSource';
import AqaSourceResponse from '../model/AqaSourceResponse';
import AqaTableQualityDefinition from '../model/AqaTableQualityDefinition';
import AqaVectorDistributionColours from '../model/AqaVectorDistributionColours';
import AqaVectorQualityDefinition from '../model/AqaVectorQualityDefinition';
import AqaVectorQualityDefinitionArchive from '../model/AqaVectorQualityDefinitionArchive';
import AqaVectorQualityDefinitionTable from '../model/AqaVectorQualityDefinitionTable';
import FolderCreationUpdateRequest from '../model/FolderCreationUpdateRequest';
import SourceCreationRequest from '../model/SourceCreationRequest';
import SourceEditRequest from '../model/SourceEditRequest';
import SourceFolderList from '../model/SourceFolderList';
import SourceidSnapshotsBody from '../model/SourceidSnapshotsBody';
import V1QualityDefinitionBody from '../model/V1QualityDefinitionBody';

/**
* AQAAnalysisController service.
* @module api/AQAAnalysisControllerApi
* @version v0
*/
export default class AQAAnalysisControllerApi {

    /**
    * Constructs a new AQAAnalysisControllerApi. 
    * @alias module:api/AQAAnalysisControllerApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the assignQualityDefinition operation.
     * @callback moduleapi/AQAAnalysisControllerApi~assignQualityDefinitionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Assigns an AQD to a source or creates a new source for it. Specify \&quot;new\&quot; for sourceId if a new source must be created
     * @param {String} qualityDefinitionId 
     * @param {String} sourceId 
     * @param {module:api/AQAAnalysisControllerApi~assignQualityDefinitionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    assignQualityDefinition(qualityDefinitionId, sourceId, callback) {
      
      let postBody = null;
      // verify the required parameter 'qualityDefinitionId' is set
      if (qualityDefinitionId === undefined || qualityDefinitionId === null) {
        throw new Error("Missing the required parameter 'qualityDefinitionId' when calling assignQualityDefinition");
      }
      // verify the required parameter 'sourceId' is set
      if (sourceId === undefined || sourceId === null) {
        throw new Error("Missing the required parameter 'sourceId' when calling assignQualityDefinition");
      }

      let pathParams = {
        'qualityDefinitionId': qualityDefinitionId,'sourceId': sourceId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/qualityDefinition/{qualityDefinitionId}/source/{sourceId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the charsets operation.
     * @callback moduleapi/AQAAnalysisControllerApi~charsetsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'String'>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns a list of periodicities
     * @param {module:api/AQAAnalysisControllerApi~charsetsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    charsets(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = ['String'];

      return this.apiClient.callApi(
        '/api/v1/charsets', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the checkOtp operation.
     * @callback moduleapi/AQAAnalysisControllerApi~checkOtpCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Checks a 6 digit OTP against the current user
     * @param {String} sixDigitCode 
     * @param {module:api/AQAAnalysisControllerApi~checkOtpCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    checkOtp(sixDigitCode, callback) {
      
      let postBody = null;
      // verify the required parameter 'sixDigitCode' is set
      if (sixDigitCode === undefined || sixDigitCode === null) {
        throw new Error("Missing the required parameter 'sixDigitCode' when calling checkOtp");
      }

      let pathParams = {
        'sixDigitCode': sixDigitCode
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/otp/check/{sixDigitCode}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the chgSource operation.
     * @callback moduleapi/AQAAnalysisControllerApi~chgSourceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Modifies a source, you change its name and description
     * @param {module:model/SourceEditRequest} body 
     * @param {String} id 
     * @param {module:api/AQAAnalysisControllerApi~chgSourceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    chgSource(body, id, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling chgSource");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling chgSource");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/sources/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the clearInterruptedPurchase operation.
     * @callback moduleapi/AQAAnalysisControllerApi~clearInterruptedPurchaseCallback
     * @param {String} error Error message, if any.
     * @param {'String'{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Clears Interrupted Purchases
     * @param {module:api/AQAAnalysisControllerApi~clearInterruptedPurchaseCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    clearInterruptedPurchase(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = 'String';

      return this.apiClient.callApi(
        '/api/v1/purchases/clear', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the createFolder operation.
     * @callback moduleapi/AQAAnalysisControllerApi~createFolderCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a new folder
     * @param {module:model/FolderCreationUpdateRequest} body 
     * @param {module:api/AQAAnalysisControllerApi~createFolderCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    createFolder(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling createFolder");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/folders', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the createPaymentMethodIntent operation.
     * @callback moduleapi/AQAAnalysisControllerApi~createPaymentMethodIntentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a Stripe Payment Intent
     * @param {module:api/AQAAnalysisControllerApi~createPaymentMethodIntentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    createPaymentMethodIntent(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/paymentmethods/createintent', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the createSource operation.
     * @callback moduleapi/AQAAnalysisControllerApi~createSourceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a source
     * @param {module:model/SourceCreationRequest} body 
     * @param {module:api/AQAAnalysisControllerApi~createSourceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    createSource(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling createSource");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/sources', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the createSourceInFolder operation.
     * @callback moduleapi/AQAAnalysisControllerApi~createSourceInFolderCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a source in a folder.
     * @param {module:model/SourceCreationRequest} body 
     * @param {String} id 
     * @param {module:api/AQAAnalysisControllerApi~createSourceInFolderCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    createSourceInFolder(body, id, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling createSourceInFolder");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling createSourceInFolder");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/folders/{id}/sources', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the createTableQualityDefinition operation.
     * @callback moduleapi/AQAAnalysisControllerApi~createTableQualityDefinitionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This saves or creates an AqaTableQualityDefinition object. Its id is the same as the source it is attached to.
     * @param {module:model/AqaTableQualityDefinition} body 
     * @param {module:api/AQAAnalysisControllerApi~createTableQualityDefinitionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    createTableQualityDefinition(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling createTableQualityDefinition");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/tablequalities', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the createVectorQualityDefinition operation.
     * @callback moduleapi/AQAAnalysisControllerApi~createVectorQualityDefinitionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This saves or creates a AqaVectorQualityDefinition object. Make sure you craft its id carefully
     * @param {module:model/AqaVectorQualityDefinition} body 
     * @param {module:api/AQAAnalysisControllerApi~createVectorQualityDefinitionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    createVectorQualityDefinition(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling createVectorQualityDefinition");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/qualities', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the dataTypes operation.
     * @callback moduleapi/AQAAnalysisControllerApi~dataTypesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'String'>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns a list of data type names, in the same order they appear in typeCounts for vector and tables
     * @param {module:api/AQAAnalysisControllerApi~dataTypesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    dataTypes(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = ['String'];

      return this.apiClient.callApi(
        '/api/v1/types', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the delMultipleSources operation.
     * @callback moduleapi/AQAAnalysisControllerApi~delMultipleSourcesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Deletes multiple sources and all its slots permanently.
     * @param {module:model/SourceFolderList} body 
     * @param {module:api/AQAAnalysisControllerApi~delMultipleSourcesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    delMultipleSources(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling delMultipleSources");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/sources/bulk', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the delSource operation.
     * @callback moduleapi/AQAAnalysisControllerApi~delSourceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Deletes a source and all its slots permanently.
     * @param {String} id 
     * @param {module:api/AQAAnalysisControllerApi~delSourceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    delSource(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling delSource");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/sources/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the delete2FAProfile operation.
     * @callback moduleapi/AQAAnalysisControllerApi~delete2FAProfileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Deletes the current user&#x27;s 2FA data, in effect disabling their 2FA set up
     * @param {module:api/AQAAnalysisControllerApi~delete2FAProfileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    delete2FAProfile(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/otp/delete', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteFolder operation.
     * @callback moduleapi/AQAAnalysisControllerApi~deleteFolderCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Deletes a folder
     * @param {String} id 
     * @param {module:api/AQAAnalysisControllerApi~deleteFolderCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    deleteFolder(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteFolder");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/folders/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deletePaymentMethod operation.
     * @callback moduleapi/AQAAnalysisControllerApi~deletePaymentMethodCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaPaymentMethod>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Deletes a payment method and returns the list of remaining payment methods
     * @param {String} paymentMethodId 
     * @param {module:api/AQAAnalysisControllerApi~deletePaymentMethodCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    deletePaymentMethod(paymentMethodId, callback) {
      
      let postBody = null;
      // verify the required parameter 'paymentMethodId' is set
      if (paymentMethodId === undefined || paymentMethodId === null) {
        throw new Error("Missing the required parameter 'paymentMethodId' when calling deletePaymentMethod");
      }

      let pathParams = {
        'paymentMethodId': paymentMethodId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaPaymentMethod];

      return this.apiClient.callApi(
        '/api/v1/paymentmethods/{paymentMethodId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the dir operation.
     * @callback moduleapi/AQAAnalysisControllerApi~dirCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaFolder>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a list of all folders
     * @param {module:api/AQAAnalysisControllerApi~dirCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    dir(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaFolder];

      return this.apiClient.callApi(
        '/api/v1/folders', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the downloadQualityDefinition operation.
     * @callback moduleapi/AQAAnalysisControllerApi~downloadQualityDefinitionCallback
     * @param {String} error Error message, if any.
     * @param {'Blob'{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a quality definition for a source and forces browser&#x27;s save as.
     * @param {String} sourceId 
     * @param {module:api/AQAAnalysisControllerApi~downloadQualityDefinitionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    downloadQualityDefinition(sourceId, callback) {
      
      let postBody = null;
      // verify the required parameter 'sourceId' is set
      if (sourceId === undefined || sourceId === null) {
        throw new Error("Missing the required parameter 'sourceId' when calling downloadQualityDefinition");
      }

      let pathParams = {
        'sourceId': sourceId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = 'Blob';

      return this.apiClient.callApi(
        '/api/v1/sources/{sourceId}/qualityDefinition/download', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the get2FAProfile operation.
     * @callback moduleapi/AQAAnalysisControllerApi~get2FAProfileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaOtpResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Check success field, if true: 2FA is set up and qrUrl contains the qrCode, otherwise the message gives you more details
     * @param {Number} ts 
     * @param {module:api/AQAAnalysisControllerApi~get2FAProfileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    get2FAProfile(ts, callback) {
      
      let postBody = null;
      // verify the required parameter 'ts' is set
      if (ts === undefined || ts === null) {
        throw new Error("Missing the required parameter 'ts' when calling get2FAProfile");
      }

      let pathParams = {
        'ts': ts
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = AqaOtpResponse;

      return this.apiClient.callApi(
        '/api/v1/otp/profile/{ts}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getDistributionColours operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getDistributionColoursCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaVectorDistributionColours{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets Vector Disribution colours
     * @param {String} id 
     * @param {module:api/AQAAnalysisControllerApi~getDistributionColoursCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getDistributionColours(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getDistributionColours");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaVectorDistributionColours;

      return this.apiClient.callApi(
        '/api/v1/distributions/colours/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getFolder operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getFolderCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaFolder{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a folder
     * @param {String} folderId 
     * @param {module:api/AQAAnalysisControllerApi~getFolderCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getFolder(folderId, callback) {
      
      let postBody = null;
      // verify the required parameter 'folderId' is set
      if (folderId === undefined || folderId === null) {
        throw new Error("Missing the required parameter 'folderId' when calling getFolder");
      }

      let pathParams = {
        'folderId': folderId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaFolder;

      return this.apiClient.callApi(
        '/api/v1/folders/{folderId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getFoldersSourceIsIn operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getFoldersSourceIsInCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaFolder>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets all the folders this source is in
     * @param {String} id 
     * @param {module:api/AQAAnalysisControllerApi~getFoldersSourceIsInCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getFoldersSourceIsIn(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getFoldersSourceIsIn");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaFolder];

      return this.apiClient.callApi(
        '/api/v1/sources/{id}/folders', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getPaymentMethods operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getPaymentMethodsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaPaymentMethod>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns a list of payment methods
     * @param {module:api/AQAAnalysisControllerApi~getPaymentMethodsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getPaymentMethods(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaPaymentMethod];

      return this.apiClient.callApi(
        '/api/v1/paymentmethods', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getPersonalisationSettings operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getPersonalisationSettingsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaPersonalisationSettings{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets the accounts setup (ie. no. of Sources and Editors)
     * @param {module:api/AQAAnalysisControllerApi~getPersonalisationSettingsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getPersonalisationSettings(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaPersonalisationSettings;

      return this.apiClient.callApi(
        '/api/v1/settings/personalisation', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getQualities operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getQualitiesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaVectorQualityDefinitionTable{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This retrieves an object containing all the existing Qualities for a source. (You will need to parse the id of each quality to determine which vector it belongs to)
     * @param {String} sourceId 
     * @param {module:api/AQAAnalysisControllerApi~getQualitiesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getQualities(sourceId, callback) {
      
      let postBody = null;
      // verify the required parameter 'sourceId' is set
      if (sourceId === undefined || sourceId === null) {
        throw new Error("Missing the required parameter 'sourceId' when calling getQualities");
      }

      let pathParams = {
        'sourceId': sourceId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaVectorQualityDefinitionTable;

      return this.apiClient.callApi(
        '/api/v1/sources/{sourceId}/qualities', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getQuality operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getQualityCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaVectorQualityDefinition{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This retrieves a AqaVectorQualityDefinition object for a given source, orientation, and vector index. Make sure you craft the id correctly
     * @param {String} qualityId 
     * @param {module:api/AQAAnalysisControllerApi~getQualityCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getQuality(qualityId, callback) {
      
      let postBody = null;
      // verify the required parameter 'qualityId' is set
      if (qualityId === undefined || qualityId === null) {
        throw new Error("Missing the required parameter 'qualityId' when calling getQuality");
      }

      let pathParams = {
        'qualityId': qualityId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaVectorQualityDefinition;

      return this.apiClient.callApi(
        '/api/v1/qualities/{qualityId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getQualityDefinition operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getQualityDefinitionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaQualityDefinition{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a quality definition for a source.
     * @param {String} sourceId 
     * @param {module:api/AQAAnalysisControllerApi~getQualityDefinitionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getQualityDefinition(sourceId, callback) {
      
      let postBody = null;
      // verify the required parameter 'sourceId' is set
      if (sourceId === undefined || sourceId === null) {
        throw new Error("Missing the required parameter 'sourceId' when calling getQualityDefinition");
      }

      let pathParams = {
        'sourceId': sourceId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaQualityDefinition;

      return this.apiClient.callApi(
        '/api/v1/sources/{sourceId}/qualityDefinition', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getQualityDefinitions operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getQualityDefinitionsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaQualityDefinitionResponse>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns a list of AQDs, filtered by compatibility with a source if the Source Id extra parameter is specified
     * @param {Object} opts Optional parameters
     * @param {String} opts.compatibleSourceId 
     * @param {module:api/AQAAnalysisControllerApi~getQualityDefinitionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getQualityDefinitions(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        'compatibleSourceId': opts['compatibleSourceId']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaQualityDefinitionResponse];

      return this.apiClient.callApi(
        '/api/v1/qualitydefinitions/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getScores operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getScoresCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaScore>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This retrieves at most number of scores for the latest files in the provided source.
     * @param {String} sourceId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts._number  (default to <.>)
     * @param {module:api/AQAAnalysisControllerApi~getScoresCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getScores(sourceId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'sourceId' is set
      if (sourceId === undefined || sourceId === null) {
        throw new Error("Missing the required parameter 'sourceId' when calling getScores");
      }

      let pathParams = {
        'sourceId': sourceId
      };
      let queryParams = {
        'number': opts['_number']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaScore];

      return this.apiClient.callApi(
        '/api/v1/sources/{sourceId}/scores', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getSnapshotsForSource operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getSnapshotsForSourceCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaSnapshot>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets all the snapshots of source
     * @param {String} sourceId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.start 
     * @param {String} opts.end 
     * @param {module:api/AQAAnalysisControllerApi~getSnapshotsForSourceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getSnapshotsForSource(sourceId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'sourceId' is set
      if (sourceId === undefined || sourceId === null) {
        throw new Error("Missing the required parameter 'sourceId' when calling getSnapshotsForSource");
      }

      let pathParams = {
        'sourceId': sourceId
      };
      let queryParams = {
        'start': opts['start'],'end': opts['end']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaSnapshot];

      return this.apiClient.callApi(
        '/api/v1/sources/{sourceId}/snapshots', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getSourcesCompatibleWithAqd operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getSourcesCompatibleWithAqdCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaSourceResponse>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns a list of Sources compatible with the provided AQD
     * @param {String} qualityDefinitionId 
     * @param {module:api/AQAAnalysisControllerApi~getSourcesCompatibleWithAqdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getSourcesCompatibleWithAqd(qualityDefinitionId, callback) {
      
      let postBody = null;
      // verify the required parameter 'qualityDefinitionId' is set
      if (qualityDefinitionId === undefined || qualityDefinitionId === null) {
        throw new Error("Missing the required parameter 'qualityDefinitionId' when calling getSourcesCompatibleWithAqd");
      }

      let pathParams = {
        'qualityDefinitionId': qualityDefinitionId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaSourceResponse];

      return this.apiClient.callApi(
        '/api/v1/sources/qualitydefinition/{qualityDefinitionId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getStripePublishableKey operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getStripePublishableKeyCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns system information for debugging purposes
     * @param {module:api/AQAAnalysisControllerApi~getStripePublishableKeyCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getStripePublishableKey(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/stripepk', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getSupportedExtensions operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getSupportedExtensionsCallback
     * @param {String} error Error message, if any.
     * @param {Object.<String, {'String': ['String']}>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets a list of all folders
     * @param {module:api/AQAAnalysisControllerApi~getSupportedExtensionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getSupportedExtensions(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = {'String': ['String']};

      return this.apiClient.callApi(
        '/api/v1/supportedextensions', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getTableQualityDefinition operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getTableQualityDefinitionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaTableQualityDefinition{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This retrieves an AqaTableQualityDefinition object for a given source Id
     * @param {String} sourceId 
     * @param {module:api/AQAAnalysisControllerApi~getTableQualityDefinitionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getTableQualityDefinition(sourceId, callback) {
      
      let postBody = null;
      // verify the required parameter 'sourceId' is set
      if (sourceId === undefined || sourceId === null) {
        throw new Error("Missing the required parameter 'sourceId' when calling getTableQualityDefinition");
      }

      let pathParams = {
        'sourceId': sourceId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaTableQualityDefinition;

      return this.apiClient.callApi(
        '/api/v1/tablequalities/{sourceId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getVectorQualityDefinitionArchive operation.
     * @callback moduleapi/AQAAnalysisControllerApi~getVectorQualityDefinitionArchiveCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaVectorQualityDefinitionArchive>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This retrieves all the archived VQDs of a given vqd
     * @param {String} vqdId 
     * @param {module:api/AQAAnalysisControllerApi~getVectorQualityDefinitionArchiveCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getVectorQualityDefinitionArchive(vqdId, callback) {
      
      let postBody = null;
      // verify the required parameter 'vqdId' is set
      if (vqdId === undefined || vqdId === null) {
        throw new Error("Missing the required parameter 'vqdId' when calling getVectorQualityDefinitionArchive");
      }

      let pathParams = {
        'vqdId': vqdId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaVectorQualityDefinitionArchive];

      return this.apiClient.callApi(
        '/api/v1/qualities/archive/{vqdId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the importQualityDefinition operation.
     * @callback moduleapi/AQAAnalysisControllerApi~importQualityDefinitionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaQualityDefinitionUpdateResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Imports a Quality Definition bundle and returns id and compatible sources
     * @param {Object} opts Optional parameters
     * @param {module:model/V1QualityDefinitionBody} opts.body 
     * @param {module:api/AQAAnalysisControllerApi~importQualityDefinitionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    importQualityDefinition(opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaQualityDefinitionUpdateResponse;

      return this.apiClient.callApi(
        '/api/v1/qualityDefinition', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the invalidateToken operation.
     * @callback moduleapi/AQAAnalysisControllerApi~invalidateTokenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns system information for debugging purposes
     * @param {String} authorization 
     * @param {module:api/AQAAnalysisControllerApi~invalidateTokenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    invalidateToken(authorization, callback) {
      
      let postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling invalidateToken");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        'Authorization': authorization
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/invalidateToken', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the listAccounts operation.
     * @callback moduleapi/AQAAnalysisControllerApi~listAccountsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaAccountResponse>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns a list of existing accounts
     * @param {module:api/AQAAnalysisControllerApi~listAccountsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    listAccounts(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = [AqaAccountResponse];

      return this.apiClient.callApi(
        '/api/v1/accounts', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the otp operation.
     * @callback moduleapi/AQAAnalysisControllerApi~otpCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaOtpResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This creates a new key for the user and returns its QR code. If called when the user already has a key, a new one is generated (and it invalidates any previous Authenticator entry)
     * @param {module:api/AQAAnalysisControllerApi~otpCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    otp(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = AqaOtpResponse;

      return this.apiClient.callApi(
        '/api/v1/otp/setget', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the putSourceInFolder operation.
     * @callback moduleapi/AQAAnalysisControllerApi~putSourceInFolderCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Puts a source in a folder (And you can add the same source in several folders with several calls)
     * @param {String} folderId 
     * @param {String} sourceId 
     * @param {module:api/AQAAnalysisControllerApi~putSourceInFolderCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    putSourceInFolder(folderId, sourceId, callback) {
      
      let postBody = null;
      // verify the required parameter 'folderId' is set
      if (folderId === undefined || folderId === null) {
        throw new Error("Missing the required parameter 'folderId' when calling putSourceInFolder");
      }
      // verify the required parameter 'sourceId' is set
      if (sourceId === undefined || sourceId === null) {
        throw new Error("Missing the required parameter 'sourceId' when calling putSourceInFolder");
      }

      let pathParams = {
        'folderId': folderId,'sourceId': sourceId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/folders/{folderId}/sources/{sourceId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the remveSourceFromFolder operation.
     * @callback moduleapi/AQAAnalysisControllerApi~remveSourceFromFolderCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * removes a source from a folder (no effect if source was not there in the first place)
     * @param {String} folderId 
     * @param {String} sourceId 
     * @param {module:api/AQAAnalysisControllerApi~remveSourceFromFolderCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    remveSourceFromFolder(folderId, sourceId, callback) {
      
      let postBody = null;
      // verify the required parameter 'folderId' is set
      if (folderId === undefined || folderId === null) {
        throw new Error("Missing the required parameter 'folderId' when calling remveSourceFromFolder");
      }
      // verify the required parameter 'sourceId' is set
      if (sourceId === undefined || sourceId === null) {
        throw new Error("Missing the required parameter 'sourceId' when calling remveSourceFromFolder");
      }

      let pathParams = {
        'folderId': folderId,'sourceId': sourceId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/folders/{folderId}/sources/{sourceId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the renameFolder operation.
     * @callback moduleapi/AQAAnalysisControllerApi~renameFolderCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Renames a folder
     * @param {module:model/FolderCreationUpdateRequest} body 
     * @param {String} folderId 
     * @param {module:api/AQAAnalysisControllerApi~renameFolderCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    renameFolder(body, folderId, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling renameFolder");
      }
      // verify the required parameter 'folderId' is set
      if (folderId === undefined || folderId === null) {
        throw new Error("Missing the required parameter 'folderId' when calling renameFolder");
      }

      let pathParams = {
        'folderId': folderId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/folders/{folderId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the selectDefaultPaymentMethod operation.
     * @callback moduleapi/AQAAnalysisControllerApi~selectDefaultPaymentMethodCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaPaymentMethod>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns a list of payment methods
     * @param {String} paymentMethodId 
     * @param {module:api/AQAAnalysisControllerApi~selectDefaultPaymentMethodCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    selectDefaultPaymentMethod(paymentMethodId, callback) {
      
      let postBody = null;
      // verify the required parameter 'paymentMethodId' is set
      if (paymentMethodId === undefined || paymentMethodId === null) {
        throw new Error("Missing the required parameter 'paymentMethodId' when calling selectDefaultPaymentMethod");
      }

      let pathParams = {
        'paymentMethodId': paymentMethodId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaPaymentMethod];

      return this.apiClient.callApi(
        '/api/v1/paymentmethods/{paymentMethodId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the setFolders operation.
     * @callback moduleapi/AQAAnalysisControllerApi~setFoldersCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Sets the folders this source appears in
     * @param {module:model/SourceFolderList} body 
     * @param {String} id 
     * @param {module:api/AQAAnalysisControllerApi~setFoldersCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    setFolders(body, id, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling setFolders");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setFolders");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/sources/{id}/folders', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the setPersonalisationSettings operation.
     * @callback moduleapi/AQAAnalysisControllerApi~setPersonalisationSettingsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns a list of payment methods
     * @param {module:model/AqaPersonalisationSettings} body 
     * @param {module:api/AQAAnalysisControllerApi~setPersonalisationSettingsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    setPersonalisationSettings(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling setPersonalisationSettings");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/settings/personalisation', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the source operation.
     * @callback moduleapi/AQAAnalysisControllerApi~sourceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaSource{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns a source
     * @param {String} id 
     * @param {module:api/AQAAnalysisControllerApi~sourceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    source(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling source");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaSource;

      return this.apiClient.callApi(
        '/api/v1/sources/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the sources operation.
     * @callback moduleapi/AQAAnalysisControllerApi~sourcesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaSource>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves all sources. Set request parameter &#x27;independent&#x27; to true to only get sources NOT in a folder.
     * @param {Object} opts Optional parameters
     * @param {String} opts.independent  (default to <.>)
     * @param {module:api/AQAAnalysisControllerApi~sourcesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    sources(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        'independent': opts['independent']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaSource];

      return this.apiClient.callApi(
        '/api/v1/sources', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the sourcesInFolder operation.
     * @callback moduleapi/AQAAnalysisControllerApi~sourcesInFolderCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AqaSource>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves all sources in folder
     * @param {String} id 
     * @param {module:api/AQAAnalysisControllerApi~sourcesInFolderCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    sourcesInFolder(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling sourcesInFolder");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = [AqaSource];

      return this.apiClient.callApi(
        '/api/v1/folders/{id}/sources', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the uploadFile operation.
     * @callback moduleapi/AQAAnalysisControllerApi~uploadFileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaSnapshotResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Uploads a file into a source
     * @param {String} sourceid 
     * @param {Object} opts Optional parameters
     * @param {module:model/SourceidSnapshotsBody} opts.body 
     * @param {module:api/AQAAnalysisControllerApi~uploadFileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    uploadFile(sourceid, opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];
      // verify the required parameter 'sourceid' is set
      if (sourceid === undefined || sourceid === null) {
        throw new Error("Missing the required parameter 'sourceid' when calling uploadFile");
      }

      let pathParams = {
        'sourceid': sourceid
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaSnapshotResponse;

      return this.apiClient.callApi(
        '/api/v1/sources/{sourceid}/snapshots', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the uploadQualityDefinition operation.
     * @callback moduleapi/AQAAnalysisControllerApi~uploadQualityDefinitionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Uploads an AQD
     * @param {module:model/AqaQualityDefinition} body 
     * @param {String} sourceId 
     * @param {module:api/AQAAnalysisControllerApi~uploadQualityDefinitionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    uploadQualityDefinition(body, sourceId, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling uploadQualityDefinition");
      }
      // verify the required parameter 'sourceId' is set
      if (sourceId === undefined || sourceId === null) {
        throw new Error("Missing the required parameter 'sourceId' when calling uploadQualityDefinition");
      }

      let pathParams = {
        'sourceId': sourceId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json;charset=UTF-8', 'application/json; charset=UTF-8'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/sources/{sourceId}/qualityDefinition', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}